module.exports = function() {
  return new Worker(__webpack_public_path__ + "e5515f5d1e50f384dd49.worker.js");
};